<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 20 22"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M12 2.414l-10 10V15h2.586l10-10L12 2.414zM19 20c.552 0 1 .448 1 1s-.448 1-1 1H1c-.552 0-1-.448-1-1s.448-1 1-1zM12.707.293l4 4c.39.39.39 1.024 0 1.414l-11 11C5.52 16.895 5.265 17 5 17H1c-.552 0-1-.448-1-1v-4c0-.265.105-.52.293-.707l11-11c.39-.39 1.024-.39 1.414 0z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-administration",
  components: {},
})
export class IconAdministration extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconAdministration;
</script>
